<p-toast></p-toast>
<div styleClass="p-card-shadow" class="card dashboardTable">
    <p-table  #dt [value]="userRidList" [rows]="10" [paginator]="true" [globalFilterFields]="[
        'AppId',
        'Farmer_Name',
        'FarmerMobile',
        'Village',
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Lot_No"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines" [tableStyle]="{'max-width': '80rem'}">

        <ng-template pTemplate="caption">
            <div class="grid d-flex align-items-center justify-content-end"
                [ngStyle]="{'color': 'white', 'background-color': 'grey'}">
                <!-- Left side -->
                <div class="col-12 md:col-4">
                    <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'white'}">{{ 'Print NOC' }}</h5>
                </div>

                <!-- Middle section for buttons -->
                <div class="col-12 md:col-4 d-flex justify-content-center">
                    <!-- <label class="pr-2">{{ 'User Filter' }}</label>
                    <p-dropdown [options]="miUnderProcFilterList" appendTo="body" (onChange)="onSelectMIConsFilter()" [(ngModel)]="selectedMIUnderProcFilter"
                        placeholder="{{'ALL'| translate}}" optionLabel="actionLevel" [showClear]="true"></p-dropdown> -->
                </div>

                <!-- Right side for search -->
                <div class="col-12 md:col-4 gap-3 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH' | translate}}" />
                    </span>
                    <!-- <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT' | translate}}"
                        icon="pi pi-upload" class="p-button-help m-3"></button>
                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu> -->
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>App ID</th>
                <th>Farmer Name</th>
                <th>Farmer Mobile</th>
                <th>Village</th>
                <th>View NOC</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td> {{ rowData.AppId}}</td>
                <td>{{rowData.Farmer_Name}}</td>
                <td>{{rowData.FarmerMobile}}</td>
                <td>{{rowData.Village}}</td>
                <!-- <td>{{rowData.UHBVN_NOC_PDF_Path}}</td> -->
                <td>
                    <a *ngIf="rowData?.UHBVN_NOC_PDF_Path && rowData?.UHBVN_NOC_PDF_Path != 'string'"
                        style="cursor: pointer" icon="pi pi-eye" [href]="rowData?.UHBVN_NOC_PDF_Path" target="_blank">
                        <button pButton type="button"
                            class="p-button-rounded p-button-accent p-button-secondary p-button-rounded" pTooltip="View"
                            icon="pi pi-eye"></button>
                    </a>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">No Data found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>